<template>
  <div>
    <SlideShowSection />
    <HomeSection />
  </div>
</template>

<script>
import HomeSection from "../components/sections/HomeSection.vue";
import SlideShowSection from "../components/sections/SlideShowSection.vue";

export default {
  components: {
    SlideShowSection,
    HomeSection,
  },
};
</script>
